import script from "./HarvestLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./HarvestLeaderboard.vue?vue&type=script&setup=true&lang=js"

import "./HarvestLeaderboard.vue?vue&type=style&index=0&id=7441df68&lang=sass"

const __exports__ = script;

export default __exports__